import { render, staticRenderFns } from "./ContactEditAddressEmailSettings.vue?vue&type=template&id=e881a12e&scoped=true"
import script from "./ContactEditAddressEmailSettings.vue?vue&type=script&lang=ts"
export * from "./ContactEditAddressEmailSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e881a12e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e881a12e')) {
      api.createRecord('e881a12e', component.options)
    } else {
      api.reload('e881a12e', component.options)
    }
    module.hot.accept("./ContactEditAddressEmailSettings.vue?vue&type=template&id=e881a12e&scoped=true", function () {
      api.rerender('e881a12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactEditAddressEmailSettings.vue"
export default component.exports